module.exports = __webpack_public_path__ + "img/third4.a07513d9.svg";